<template>
  <section class="section-container">
    <h2 class="section-title">{{ $t('home-page.services.title') }}</h2>
    <p class="section-subtitle">Our comprehensive consultancy services address the unique challenges of logistics and transportation companies</p>

    <div class="services-grid">
      <div class="service-card" data-aos="fade-up">
        <img src="@/assets/rectangle-14@2x.png" alt="Freight Shipping">
        <div class="card-content">
          <h4>{{ $t('home-page.services.service-title[0]') }}</h4>
        </div>
      </div>
      <div class="service-card" data-aos="fade-up" data-aos-delay="100">
        <img src="@/assets/rectangle-15@2x.png" alt="Fleet Management">
        <div class="card-content">
          <h4>{{ $t('home-page.services.service-title[1]') }}</h4>
        </div>
      </div>
      <div class="service-card" data-aos="fade-up" data-aos-delay="200">
        <img src="@/assets/rectangle-16@2x.png" alt="Safety, Health, and Environment">
        <div class="card-content">
          <h4>{{ $t('home-page.services.service-title[2]') }}</h4>
        </div>
      </div>
      <div class="service-card" data-aos="fade-up" data-aos-delay="300">
        <img src="@/assets/logisticsTraining.webp" alt="Logistics Training">
        <div class="card-content">
          <h4>{{ $t('home-page.services.service-title[3]') }}</h4>
        </div>
      </div>
    </div>

    <div class="cta-container">
      <router-link to="/services" class="btn-primary">{{ $t('home-page.services.see-more') }}</router-link>
      <router-link to="/training" class="btn-secondary">{{ $t('home-page.services.training') }}</router-link>
    </div>
  </section>
</template>

<style scoped>
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.service-card {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}
.service-card img {
  width: 100%;
  height: 180px;
  object-fit: cover;
}
.card-content {
  padding: 1.5rem;
}
.card-content h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.cta-container {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 4rem;
}
.btn-primary, .btn-secondary {
  padding: 14px 28px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  text-transform: uppercase;
  font-size: 0.9rem;
}
.btn-primary {
  background-color: #0A2D61;
  color: white;
}
.btn-primary:hover {
  background-color: #1c4b8d;
}
.btn-secondary {
  background-color: transparent;
  color: #0A2D61;
  border: 2px solid #0A2D61;
}
.btn-secondary:hover {
  background-color: #0A2D61;
  color: white;
}
</style>